import React from 'react';
import { useParams } from 'react-router-dom';

const LeadDetailPage: React.FC = () => {
  const { leadId } = useParams<{ leadId: string }>();

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
        Lead Details
      </h1>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <p className="text-gray-600 dark:text-gray-300">
          Viewing lead: {leadId}
        </p>
      </div>
    </div>
  );
};

export default LeadDetailPage;
